export default __webpack_public_path__ + "095d53008429b0b96bd26fbec6eee5c0.svg";